




import { defineComponent } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { MessageLink } from "@scrile/api-provider/dist/api/MessageLinksProvider";
import providers from "@/lib/api";
import MessageItemLinkView from "./MessageItemLinkView.vue";

export default defineComponent({
  name: "MessageItemLink",
  components: { MessageItemLinkView },
  props: {
    messageLink: { type: Object as () => MessageLink, required: true },
  },
  data() {
    return {
      contentSet: null as ContentSet | null,
      loading: false,
      isDeleted: false,
    };
  },
  async created() {
    try {
      this.loading = true;
      providers.ContentSetProvider.setReceiveErrors(false);
      this.contentSet = await providers.ContentSetProvider.findById({
        id: this.messageLink.subject.subjectId,
      });
    } catch (e) {
      this.isDeleted = true;
    } finally {
      this.loading = false;
    }
  },
});
